import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { BankAccountFilters } from '../../../commons/models/bank-account.model';

@Component({
  selector: 'app-bank-account-filters',
  templateUrl: './bank-account-filters.component.html',
  styleUrls: ['./bank-account-filters.component.scss']
})
export class BankAccountFiltersComponent {
  @Output()
  onFilter: EventEmitter<BankAccountFilters> = new EventEmitter();

  private _defaultFilters: BankAccountFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getBankAccount());
  }

  private _getBankAccount(): BankAccountFilters {
    let filters: BankAccountFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): BankAccountFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: BankAccountFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
